import { EntrySearch } from "@models/entry";
import { buildSpatieSort } from "../shared/utils/buildSpatieSort";

export type EntryInclude = "document" | "document.documentSettings" | "counterAccount";

export type EntrySortField =
  | "id"
  | "business_id"
  | "account_id"
  | "document_id"
  | "entry_name"
  | "debit"
  | "credit"
  | "counter_account_id"
  | "doc_name_2"
  | "doc_num_2"
  | "ref_2"
  | "value"
  | "info"
  | "created_at"
  | "updated_at";

export type EntrySort = EntrySortField | `-${EntrySortField}`;

const ENTRY_SORT_FIELDS: EntrySortField[] = [
  "id",
  "business_id",
  "account_id",
  "document_id",
  "entry_name",
  "debit",
  "credit",
  "counter_account_id",
  "doc_name_2",
  "doc_num_2",
  "ref_2",
  "value",
  "info",
  "created_at",
  "updated_at",
];

export const ENTRY_BROWSE_INCLUDES: EntryInclude[] = ["document", "document.documentSettings", "counterAccount"];
export const ENTRY_BROWSE_PER_PAGE = 5;

export interface EntrySearchParams {
  accountId: number;
  filter?: Partial<EntrySearch>;
  include?: EntryInclude[];
  sort?: EntrySort[];
  per_page?: number;
  cursor?: string;
  useCache?: boolean;
}

/**
 * Builds the POST body for the entries Spatie browse/search endpoint.
 * @param params EntrySearchParams - Browse filters, includes, sort, and pagination.
 * @returns object - Request body fields for entries/search.
 */
export function getEntrySearchBody(params: EntrySearchParams) {

  const { filter, include, sort, per_page = ENTRY_BROWSE_PER_PAGE, cursor, useCache } = params;

  return {
    ...(filter && Object.keys(filter).length > 0 && { filter }),
    ...(include?.length && { include: include.join(",") }),
    ...(sort?.length && { sort: sort.join(",") }),
    ...(per_page && { per_page }),
    ...(cursor && { cursor }),
    ...(useCache && { use_cache: true }),
  };
}

/**
 * Builds a Spatie sort string for entry browse from column key and order.
 * @param sortKey string - Column field name from the entries table.
 * @param order "ASC" | "DESC" - Sort direction from the table.
 * @returns EntrySort - Spatie sort token accepted by the entries search API.
 */
export function buildEntrySort(sortKey: string, order: "ASC" | "DESC"): EntrySort {

  return buildSpatieSort(sortKey, order, ENTRY_SORT_FIELDS, "id") as EntrySort;
}
